import request from 'tools/request'
import { EnumEndpointState, MY_ENDPOINT_CACHE_DURATION_MS, MY_ENDPOINT_TIMEOUT_MS } from 'types/request'
import { RoleResponse } from 'types/rolePermission'

type EndpointStateType = {
  state: EnumEndpointState
  data: RoleResponse | null
  expiresAt: number
}

const myRoleEndpoint: EndpointStateType = {
  state: 'IDLE',
  data: null,
  expiresAt: 0,
}

let myRoleRequestId = 0
export const invalidateMyRoleCache = () => {
  myRoleRequestId++
  myRoleEndpoint.state = 'IDLE'
  myRoleEndpoint.data = null
  myRoleEndpoint.expiresAt = 0
}

// TECH DEBT: Refactor this and myUser to avoid code duplication
export const getMyRole = async () => {
  return new Promise<RoleResponse>((resolve, reject) => {
    const now = Date.now()
    if (myRoleEndpoint.state === 'SUCCESS' && myRoleEndpoint.expiresAt > now && myRoleEndpoint.data) {
      resolve(myRoleEndpoint.data)
      return
    }

    if (myRoleEndpoint.state === 'LOADING') {
      let elapsed = 0
      const checkInterval = setInterval(() => {
        if (myRoleEndpoint.state === 'SUCCESS' && myRoleEndpoint.data) {
          clearInterval(checkInterval)
          resolve(myRoleEndpoint.data)
        } else if (myRoleEndpoint.state === 'ERROR') {
          clearInterval(checkInterval)
          reject(new Error('Failed to fetch role data'))
        } else {
          elapsed += 100
          if (elapsed >= MY_ENDPOINT_TIMEOUT_MS) {
            clearInterval(checkInterval)
            reject(new Error('Timeout waiting for role data fetch'))
          }
        }
      }, 100)
      return
    }

    const requestId = ++myRoleRequestId
    myRoleEndpoint.state = 'LOADING'
    getMyRoleEndpoint()
      .then((role) => {
        if (requestId !== myRoleRequestId) {
          reject(new Error('Stale role data fetch'))
          return
        }
        myRoleEndpoint.state = 'SUCCESS'
        myRoleEndpoint.data = role
        myRoleEndpoint.expiresAt = Date.now() + MY_ENDPOINT_CACHE_DURATION_MS
        resolve(role)
      })
      .catch((error) => {
        if (requestId !== myRoleRequestId) {
          reject(new Error('Stale role data fetch'))
          return
        }
        myRoleEndpoint.state = 'ERROR'
        reject(error)
      })
  })
}

export const getMyRoleEndpoint = async () => {
  return await request.get<RoleResponse>(`roles/me`).then((res) => res.data)
}
